var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-poster-detail',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"pt-poster-detail__withData",attrs:{"poster":_vm.currentPoster}})}
var staticRenderFns = []

export { render, staticRenderFns }